import { Component, OnInit } from '@angular/core';
import { SalesOrderService } from '../../service/sales-order.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-limit-flow-sales-order',
  templateUrl: './sales-order.component.html',
  styleUrls: ['./sales-order.component.scss'],
  providers: [SalesOrderService]
})



export class LimitFlowSalesOrderComponent implements OnInit {

  constructor(private salesorderservice: SalesOrderService,
              private fb: FormBuilder,
              private flashMessagesService: FlashMessagesService,
              private router: Router,
              private route: ActivatedRoute) { 

                this.salesorderFlowForm = this.fb.group({
                  'Nivel': ['', Validators.required],
                  'Profile': ['', Validators.required],
                  'ValorDe': ['', Validators.required],
                  'ValorAte': ['', Validators.required],
                });

              }

  private profileList = [];
  private salesorderFlowForm : FormGroup;
  private levelEditForm :  FormGroup;

  private approverList = [];

  private levelToEdit;

  
  private selectedSegmentID = null;
  private segments = [];

   ngOnInit() {
    this.getProfile();
    this.getSegments();
  }

  getProfile(){
    this.salesorderservice.getProfile().subscribe(result =>{
      this.profileList = result.Result.filter(c => c.Descricao != "Analista de Crédito");
      console.log('this.profileList)', this.profileList);
    });
  }

  getApprovers(){
    this.levelToEdit = null;
    this.salesorderservice.getApprovers(this.selectedSegmentID).subscribe(result =>{
      if (result.Result){
        this.approverList = result.Result;
        if (this.approverList.length > 0){
        console.log("Result1",result);
        // Set Nivel initial value
        const nivel = this.approverList[this.approverList.length - 1].Nivel + 1;
        this.salesorderFlowForm.controls.Nivel.setValue(nivel);
        // Set ValorAté initial value
        const valorDe = +((this.approverList[this.approverList.length - 1].ValorAte + 0.01).toFixed(2));
        this.salesorderFlowForm.controls.ValorDe.setValue(valorDe);
        //Include the Validator of ValorAte
        const minValorAte = +((this.salesorderFlowForm.controls.ValorDe.value + 0.01).toFixed(2));
        this.salesorderFlowForm.controls.ValorAte.setValidators([Validators.min(minValorAte), Validators.required]);
        }else{
          console.log("Result2",result);
          this.salesorderFlowForm.controls.Nivel.setValue(1);
          this.salesorderFlowForm.controls.ValorDe.setValue(0);
            //Include the Validator of ValorAte
          this.salesorderFlowForm.controls.ValorAte.setValidators([Validators.min(0.01), Validators.required]);
        }
      }
    });
  }


  segmentChanged(segmentID){

    this.selectedSegmentID = segmentID;
    this.getApprovers();
    this.salesorderFlowForm.controls.Profile.reset();
    this.salesorderFlowForm.controls.ValorAte.reset();
  }

  getSegments(){
    this.salesorderservice.getSegments().subscribe(result => {
      this.segments = result.Result;
    }, error => {
      console.log(error);
    });
  }

  addLevel(){
    const saveObj = {
      SegmentoID: this.selectedSegmentID,
      Nivel: this.salesorderFlowForm.controls.Nivel.value,
      PerfilID: this.salesorderFlowForm.controls.Profile.value,
      ValorDe: this.salesorderFlowForm.controls.ValorDe.value,
      ValorAte: this.salesorderFlowForm.controls.ValorAte.value
    }
  
    console.log("OBJ to Save",saveObj);

    this.salesorderservice.insertApprover(saveObj).subscribe(result => {
      if (result.Success){
        this.flashMessagesService.show('Nível cadastrado com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
        this.segmentChanged(this.selectedSegmentID);
        this.salesorderFlowForm.controls.ValorAte.reset();
        this.salesorderFlowForm.controls.Profile.reset();
      }else{
        console.log("Something wrong here, bro!", result);
      }
    }, error => {
      console.log(error);
    });
  }

  inactivateLastNivel(){
    const lastLimitID = this.approverList[this.approverList.length - 1].ID;
    this.salesorderservice.removeApprover(lastLimitID).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show('Limite de ordem de venda excluído com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
        this.getApprovers();
        this.salesorderFlowForm.controls.ValorAte.reset();
        this.salesorderFlowForm.controls.Profile.reset();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
      
    });
  }

  editNivel(index){
    
    console.log(index);
    this.levelToEdit = this.approverList[index];
    this.levelEditForm = this.fb.group({
      'Nivel': [this.levelToEdit.Nivel, Validators.required],
      'Profile': [this.levelToEdit.PerfilID, Validators.required],
      'ValorDe': [this.levelToEdit.ValorDe, Validators.required],
      'ValorAte': [this.levelToEdit.ValorAte, Validators.required]
    });
     //Include the Validator of ValorAte
     const minValorAte = +((this.levelEditForm.controls.ValorDe.value + 0.01).toFixed(2));
     this.levelEditForm.controls.ValorAte.setValidators([Validators.min(minValorAte), Validators.required]);
  }
  
  
  onEditNivel(){

    //If its the last only updates itself
    if (this.levelToEdit.Nivel == this.approverList[this.approverList.length - 1].Nivel){
      const updateObj = {
        Nivel: this.levelToEdit.Nivel,
        ID: this.levelToEdit.ID,
        PerfilID: this.levelEditForm.controls.Profile.value,
        ValorDe: this.levelToEdit.ValorDe,
        ValorAte: this.levelEditForm.controls.ValorAte.value,
        Ativo: true
      }
      this.updateNivel(updateObj, true);

    // If not mount the first update object...
    }else{
      let updateObj = {
        Nivel: this.levelToEdit.Nivel,
        ID: this.levelToEdit.ID,
        PerfilID: this.levelEditForm.controls.Profile.value,
        ValorDe: this.levelToEdit.ValorDe,
        ValorAte: this.levelEditForm.controls.ValorAte.value,
        Ativo: true
      }
      //then calculate changes      
      const baseChange =  +(this.levelEditForm.controls.ValorAte.value - this.levelToEdit.ValorAte).toFixed(2);

      //then test if changes where made
      if (baseChange != 0){
        this.updateNivel(updateObj,false); //if changed update the first then loop
        for (var i =  this.levelToEdit.Nivel; i < this.approverList.length; i++){
          updateObj = {
            Nivel: this.approverList[i].Nivel,
            ID: this.approverList[i].ID,
            PerfilID: this.approverList[i].PerfilID,
            ValorDe: +(this.approverList[i].ValorDe + baseChange).toFixed(2),
            ValorAte: +(this.approverList[i].ValorAte + baseChange).toFixed(2),
            Ativo: true
          }
          const isLast = (i == this.approverList.length - 1)? true: false;
          this.updateNivel(updateObj, isLast); // update each changed level and test if its the last.
        }  
      }else{
        //if not change just the first one
        this.updateNivel(updateObj,true);
      }
    }
  }

  //Receives an object to update and a boolean if its the last update of a list (true if its the only one);
  updateNivel(updateObj, isLast){
    this.salesorderservice.updateApprover(updateObj).subscribe(result => {
      if (result.Success){
        this.flashMessagesService.show('Nível Editado com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
        if (isLast == true){
          this.levelToEdit = null;
          this.salesorderFlowForm.controls.ValorAte.reset();
          this.salesorderFlowForm.controls.Profile.reset();
          this.getApprovers();
        }
      }else{
        console.log("Something wrong here, bro!", result);
      }
    }, error => {
      console.log(error);
    });  
  }
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-sales-order/component/sales-order/sales-order.component.ts